<div class="modal-header">
    <h4 class="modal-title">{{ "modales.childAdded.title" | translate }}</h4>
</div>
<div class="modal-body">
    <div class="contentContainer">
        <div class="contentTitle">
            {{ "modales.childAdded.content" | translate }}
        </div>

        <div class="content">
            <div class="contentRow">
                <div class="contentLabel">
                    {{ "modales.childAdded.id" | translate }}
                </div>
                <div class="contentValue">{{ user.pseudo }}</div>
            </div>
            <div class="contentRow">
                <div class="contentLabel">
                    {{ "modales.childAdded.firstname" | translate }}
                </div>
                <div class="contentValue">{{ user.first_name }}</div>
            </div>
            <div class="contentRow">
                <div class="contentLabel">
                    {{ "modales.childAdded.lastname" | translate }}
                </div>
                <div class="contentValue">{{ user.last_name }}</div>
            </div>
        </div>

        <div class="note">
            {{ "moduleCompletion.communicateCredentials" | translate }}
        </div>
    </div>
</div>
<div class="modal-footer">
    <button (click)="validate()" type="button" class="btn btn-primary">
        {{ "common.buttons.ok" | translate }}
    </button>
</div>
